import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectUser, selectIsAuthenticated } from "store/src/slices/auth-slice";

const CLARITY_PROJECT_ID = "tercv5o73g";

export default function ClarityAnalytics() {
  const user = useSelector(selectUser);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  useEffect(() => {
    const hostname = window.location.hostname;
    if (hostname === "localhost" || hostname === "127.0.0.1" || hostname === "0.0.0.0") {
      return;
    }
    if (!isAuthenticated || !user) {
      return;
    }
    if (window.clarity) {
      identifyUser();
      return;
    }

    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);

      // Wait for Clarity to load
      const checkClarityLoaded = () => {
        if (window.clarity) {
          identifyUser();
        } else {
          setTimeout(checkClarityLoaded, 100);
        }
      };

      setTimeout(checkClarityLoaded, 100);
    })(window, document, "clarity", "script", CLARITY_PROJECT_ID);

    function identifyUser() {
      try {
        window.clarity("identify", user?.employee_id?.toString());

        if (user?.employee_id) {
          window.clarity("set", "employeeNo", user?.employee_id?.toString());
        }

        if (user?.name) {
          window.clarity("set", "userName", user?.name);
        }

        if (user?.department?.id) {
          window.clarity("set", "department", user?.department?.id);
        }

        if (user?.email) {
          window.clarity("set", "userEmail", user?.email);
        }

        if (user?.role) {
          window.clarity("set", "userRole", user?.role);
        }

        if (user?.id) {
          window.clarity("set", "userId", user.id.toString());
        }
      } catch (error) {
        console.error('❌ Clarity: Error setting tags:', error);
      }
    }
  }, [isAuthenticated, user]);

  return null;
}

export function useClarityTracking() {
  const trackEvent = (eventName, eventData = {}) => {
    if (window.clarity) {
      window.clarity("event", eventName, eventData);
    } else {
      console.warn('⚠️ Clarity not loaded, event not tracked:', eventName);
    }
  };

  const setCustomTag = (key, value) => {
    if (window.clarity) {
      window.clarity("set", key, value);
    } else {
      console.warn('⚠️ Clarity not loaded, tag not set:', key);
    }
  };

  return { trackEvent, setCustomTag };
}